/*! bxs-vue-ui v4.0.1 */
import { _ as _export, p as objectDefineProperty, n as descriptors, s as createCommonjsModule, N as path } from './es.array.join.js';
import { n as normalizeComponent } from './normalize-component.js';
import './es.number.constructor.js';
import Vue from 'vue';
import { _ as _extends } from './extends.js';
import { f as filter } from './filter.js';
import { s as some } from './some.js';
import SafeAreaPatch from '../safe-area-patch/index.js';

var context = {
  zIndex: 700,
  // 浮层信息堆栈
  stack: [],

  // 取最顶层浮层信息
  get top() {
    return this.stack[this.stack.length - 1] || {};
  }

};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'overlay',
  props: {
    visible: Boolean,
    zIndex: {
      type: Number,
      default: 700
    }
  },
  computed: {
    style: function style() {
      return {
        zIndex: this.zIndex
      };
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "enter-active-class": "bx-animate-fade-in",
      "leave-active-class": "bx-animate-fade-out"
    },
    on: {
      "afterEnter": function afterEnter($event) {
        _vm.$emit('after-enter', $event);
      },
      "afterLeave": function afterLeave($event) {
        _vm.$emit('after-leave', $event);
      },
      "leaveCancelled": function leaveCancelled($event) {
        _vm.$emit('leave-cancelled', $event);
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "bx-overlay",
    style: _vm.style,
    on: {
      "click": function click($event) {
        _vm.$emit('click', $event);
      },
      "touchmove": function touchmove($event) {
        _vm.$emit('touchmove', $event);
      }
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var manager = {
  open: function open(vm, config) {
    var _context;

    if (!some(_context = context.stack).call(_context, function (item) {
      return item.vm === vm;
    })) {
      var el = vm.$el;
      var target = el && el.parentNode ? el.parentNode : document.body;
      context.stack.push({
        vm: vm,
        config: config,
        target: target
      });
      this.update();
    }
  },
  close: function close(vm) {
    var stack = context.stack;

    if (stack.length) {
      if (context.top.vm === vm) {
        stack.pop();
        context.zIndex -= 2;
        this.update(true);
      } else {
        context.stack = filter(stack).call(stack, function (item) {
          return item.vm !== vm;
        });
      }
    }
  },
  update: function update(isClose) {
    if (isClose === void 0) {
      isClose = false;
    }

    var overlay = context.overlay;

    if (!overlay) {
      overlay = new (Vue.extend(__vue_component__))({
        el: document.createElement('div')
      });
      overlay.$on('click', this.onClick);
      overlay.$on('touchmove', this.onTouchMove); // 为了解决在iPhone 11手机上，animationEnd首次触发后，再也不触发，无法稳定复现，但是几率很高
      // 经测试，在iPhone 11上，同时存在两个「transition」组件，会产生这个问题

      overlay.$on('after-enter', this.afterEnter);
      overlay.$on('after-leave', this.afterLeaveOrCancelled); // 在遮罩层leaving过程中，可能会因为重新enter导致动画被cancelled
      // 为了保证「openAfter」与「closeAfter」调用同步

      overlay.$on('leave-cancelled', this.afterLeaveOrCancelled);
      context.overlay = overlay;
    }

    if (isClose) {
      overlay.visible = false;
    }

    var _context$top = context.top,
        config = _context$top.config,
        target = _context$top.target;

    if (target) {
      target.appendChild(overlay.$el);

      _extends(overlay, config, {
        visible: true
      });
    }
  },
  onClick: function onClick() {
    var vm = context.top.vm;

    if (vm && vm.closeOnClickOverlay) {
      vm.$emit('input', false);
      vm.$emit('overlayClose');
    }
  },
  onTouchMove: function onTouchMove(e) {
    e.preventDefault();
    e.stopPropagation();
  },
  afterEnter: function afterEnter() {
    var vm = context.top.vm;

    if (vm) {
      // 记录当前活动的浮层
      context.activeVm = vm;
      vm.openAfter();
    }
  },
  afterLeaveOrCancelled: function afterLeaveOrCancelled() {
    var activeVm = context.activeVm;

    if (activeVm) {
      activeVm.closeAfter();
      context.activeVm = null;
    }
  }
};

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperty: objectDefineProperty.f
});

var defineProperty_1 = createCommonjsModule(function (module) {
var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;
});

var defineProperty = defineProperty_1;

var defineProperty$1 = defineProperty;

var passiveSupported = false;

try {
  var options = defineProperty$1({}, 'passive', {
    get: function get() {
      passiveSupported = true;
      return passiveSupported;
    }
  });

  window.addEventListener('test', null, options);
} catch (err) {
  passiveSupported = false;
} // 添加事件


function addEvent(target, event, handler, passive) {
  if (passive === void 0) {
    passive = false;
  }

  target.addEventListener(event, handler, passiveSupported ? {
    capture: false,
    passive: passive
  } : false);
} // 移除事件

function removeEvent(target, event, handler) {
  target.removeEventListener(event, handler);
}

/**
 * 弹出层统一管理mixin
 * tips: 内部的props、data、watch、methods可能会因为与调用者同名而导致不触发（mixin局限）
 */
var MODAL_OPEN_CLASS = 'bx-overlay-open';
var Popup = {
  props: {
    // 和emit('input')配合
    value: Boolean,
    // 遮罩背景是否显示
    overlay: {
      type: Boolean,
      default: true
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    // 禁止document滚动
    lockScroll: {
      type: Boolean,
      default: false
    },
    // 防止滚动穿透，页面会有轻微闪动
    preventScrollThrough: {
      type: Boolean,
      default: false
    },
    // 是否兼容iphoneX，解决在app内不满一屏情况下的bug，废弃，改为补丁的方式
    supportIphoneX: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // 记住打开overlay时 body 的位置
      scrollTop: 0,
      // Vue挂载的节点
      appNode: null
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        if (!this.$el) {
          this.$nextTick(function () {
            return _this[val ? 'open' : 'close']();
          });
        } else {
          this[val ? 'open' : 'close']();
        }
      }
    },
    overlay: function overlay() {
      if (this.value) {
        this.renderOverlay();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.close();
  },
  deactivated: function deactivated() {
    this.close();
  },
  methods: {
    open: function open() {
      if (this.opened) {
        return false;
      }

      this.openBefore();
      this.renderOverlay();
      this.opened = true;
      return this.opened;
    },
    openBefore: function openBefore() {
      // 禁止滚动，在弹出层无需滚动时使用
      if (this.lockScroll) {
        addEvent(document, 'touchmove', this.onTouchMove);
      }
    },
    openAfter: function openAfter() {
      // 防止滚动穿透
      if (this.preventScrollThrough) {
        this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        if (!this.appNode) {
          this.appNode = this.findRootElement(this.$el);
        }

        this.appNode.classList.add(MODAL_OPEN_CLASS);
        this.appNode.style.top = -1 * this.scrollTop + "px"; // 增加了「MODAL_OPEN_CLASS」导致Body高度变化，因此需要更新安全区域补丁

        SafeAreaPatch.update();
      }
    },
    close: function close() {
      if (!this.opened) {
        return false;
      }

      this.closeBefore();
      manager.close(this);
      this.opened = false;
      return this.opened;
    },
    closeBefore: function closeBefore() {
      if (this.lockScroll) {
        removeEvent(document, 'touchmove', this.onTouchMove);
      }
    },
    // 透明遮罩动画结束后，调用
    closeAfter: function closeAfter() {
      if (this.preventScrollThrough) {
        if (this.appNode) {
          this.appNode.classList.remove(MODAL_OPEN_CLASS);
          this.appNode.style.top = null;
          window.scrollTo(0, this.scrollTop);
        } // 移除了「MODAL_OPEN_CLASS」导致Body高度变化，因此需要更新安全区域补丁


        SafeAreaPatch.update();
      }
    },
    renderOverlay: function renderOverlay() {
      var _this2 = this;

      if (this.overlay) {
        context.zIndex += 1;
        manager.open(this, {
          zIndex: context.zIndex
        });
      } else {
        manager.close(this);
      }

      this.$nextTick(function () {
        context.zIndex += 1;
        _this2.$el.style.zIndex = context.zIndex;
      });
    },
    onTouchMove: function onTouchMove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    // 查找Vue挂载的节点
    findRootElement: function findRootElement($el) {
      var $rootNode = $el;

      while ($rootNode.parentNode && $rootNode.parentNode.tagName !== 'BODY') {
        $rootNode = $rootNode.parentNode;
      }

      if ($rootNode.parentNode && $el === $rootNode) {
        $rootNode = $rootNode.parentNode;
      }

      return $rootNode;
    }
  }
};

export { Popup as P };
